import { render } from "./AddCompanyBoard.vue?vue&type=template&id=ca747284&scoped=true&ts=true"
import script from "./AddCompanyBoard.vue?vue&type=script&lang=ts"
export * from "./AddCompanyBoard.vue?vue&type=script&lang=ts"

import "./AddCompanyBoard.vue?vue&type=style&index=0&id=ca747284&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca747284"]])

export default __exports__